export default __webpack_public_path__ + "static/media/subscribe_button.42f0ca49.png";